import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export const BackButton = ({ tone = "dark", onBack, className = "" }) => {
  const navigate = useNavigate();
  const goBack = () => {
    if (onBack) return onBack();
    if (window.history.length > 1) navigate(-1);
    else navigate("/");
  };

  return (
    <button
      type="button"
      data-testid="back-button"
      onClick={goBack}
      className={`inline-flex min-h-[44px] items-center gap-2 rounded-full px-4 py-2.5 text-base font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ${tone === "light" ? "text-white hover:bg-white/15" : "text-stone-700 hover:bg-stone-100"} ${className}`}
    >
      <ArrowLeft aria-hidden="true" className="h-5 w-5" strokeWidth={2.5} />
      Back
    </button>
  );
};
